import * as React from 'react';

const TITLE = 'Bookmark';

export function BookmarkStroke() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        d="M11.6609 15.6326L6 20.858V2.5H18V20.858L12.3391 15.6326L12 15.3195L11.6609 15.6326Z"
        stroke="currentColor"
      />
    </svg>
  );
}

export function BookmarkFilled() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        d="M11.6609 15.6326L6 20.858V2.5H18V20.858L12.3391 15.6326L12 15.3195L11.6609 15.6326Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}
